import { ContainerWrapper } from '../Container'
import SectionHeading from './SectionHeading'
import SectionHeadingWrapper from './SectionHeadingWrapper'
import SectionSubText from './SectionSubText'

const rows = [
    {
        feature: 'Investor-Focused Designs',
        olm: 'Templates tested for seller response',
        standard: 'Generic layouts',
    },
    {
        feature: 'Personalization',
        olm: 'Handwritten fonts, real-ink, merge fields',
        standard: 'Limited',
    },
    {
        feature: 'Speed',
        olm: '2-day average turnaround',
        standard: '1–2+ weeks',
    },
    {
        feature: 'Coaching',
        olm: 'Free expert coaching for investors',
        standard: 'None',
    },
    {
        feature: 'Tracking & Analytics',
        olm: 'Response tracking + ROI reports',
        standard: 'Print & pray',
    },
    {
        feature: 'Customer Service',
        olm: 'Personalized, responsive support',
        standard: 'Ticket queues',
    },
]

export default function RealEstateCompetitors() {
    return (
        <ContainerWrapper>
            <section className="py-16">
                <SectionHeadingWrapper>
                    <SectionHeading>
                        <div className="space-x-2">
                            <span>Our</span>
                            <span className="olm-gradient-text leading-snug">
                                Results
                            </span>
                            <span>Speak for Themselves</span>
                        </div>
                    </SectionHeading>
                    <SectionSubText>Hear from our clients:</SectionSubText>
                </SectionHeadingWrapper>
                <div className="max-w-6xl mx-auto px-4">
                    <div className="overflow-x-auto ">
                        <table className="min-w-full text-left">
                            <thead className="bg-[#fff5ec]">
                                <tr
                                    className="border-b border-orange-300"
                                    style={{ backgroundColor: '#fff5ec' }}>
                                    <th
                                        className="p-4 text-[18px] font-semibold text-olm-black w-[32%]"
                                        style={{
                                            backgroundColor: '#fff5ec',
                                            borderColor: '#f0a366',
                                        }}>
                                        Features
                                    </th>
                                    <th
                                        className="p-4 text-[18px] font-semibold text-olm-black w-[34%]"
                                        style={{
                                            backgroundColor: '#fff5ec',
                                            borderColor: '#f0a366',
                                        }}>
                                        OLM Real Estate Postcards
                                    </th>
                                    <th
                                        className="p-4 text-[18px] font-semibold text-bl w-[34%]"
                                        style={{
                                            backgroundColor: '#fff5ec',
                                            borderColor: '#f0a366',
                                        }}>
                                        Standard Printers
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, idx) => (
                                    <tr
                                        key={idx}
                                        className="bg-white border-b border-orange-300 align-top"
                                        style={{ backgroundColor: '#fff' }}>
                                        <td
                                            className="p-4 font-semibold text-olm-black text-base"
                                            style={{ backgroundColor: '#fff' }}>
                                            {row.feature}
                                        </td>
                                        <td
                                            className="p-4 text-olm-new-black text-base"
                                            style={{ backgroundColor: '#fff' }}>
                                            {row.olm}
                                        </td>
                                        <td
                                            className="p-4 text-olm-new-black text-base"
                                            style={{ backgroundColor: '#fff' }}>
                                            {row.standard}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </ContainerWrapper>
    )
}
